import React from 'react';
import {Modal} from '@forecast-it/design-system';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

type DeleteReportModalProps = {
	closeModal: () => void;
	reportName: string;
	reportCount: number;
	callback: () => void;
};

const DeleteReportModal = ({closeModal, reportName, reportCount, callback}: DeleteReportModalProps): React.JSX.Element => {
	const deleteReport = () => {
		callback();
		closeModal();
	};
	return (
		<Modal size={Modal.SIZE.MEDIUM} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage
					id={'report.delete-report'}
					values={{
						reportCount: reportCount,
					}}
				/>
			</Modal.Title>
			<Modal.Content>
				{reportName ? (
					<FormattedHTMLMessage
						id={'report.delete-report-description'}
						values={{
							reportName: reportName,
						}}
					/>
				) : null}
				{!reportName ? (
					<FormattedHTMLMessage
						id={'report.bulk-delete-report-description'}
						values={{
							reportCount: reportCount,
						}}
					/>
				) : null}
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={deleteReport} dataCy={'modal-btn-confirm-delete'} disabled={false}>
					<FormattedMessage id="common.delete" />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id="common.cancel" />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default DeleteReportModal;
